import { AlertTriangle } from "lucide-react";
import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const payload = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      pathname: window.location.pathname,
    };

    console.group("[MetaJuntos ErrorBoundary] runtime error");
    console.error("message:", payload.message);
    console.error("stack:", payload.stack);
    console.error("componentStack:", payload.componentStack);
    console.error("pathname:", payload.pathname);
    console.error("payload:", payload);
    console.groupEnd();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background p-4 text-foreground">
          <div className="mx-auto mt-6 flex max-w-xl items-start gap-3 rounded-xl border border-gold/15 bg-white/[0.035] p-4">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
            <div>
              <h2 className="text-sm font-semibold">Erro de interface capturado</h2>
              <p className="mt-1 text-xs text-muted-foreground">
                O diagnóstico foi enviado para o console do navegador.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
